"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * format url
 * @param url
 * @param hashType
 */
var formatUrl = function (url, hashType) {
    return (hashType && url.indexOf('#') === -1) ? "#" + url : url;
};
exports.default = formatUrl;
